console.log("🟢 Variant Metafield Updater script loaded!");

document.addEventListener("DOMContentLoaded", function () {
  const variantMetafieldsElement = document.querySelector(
    '[id^="VariantMetafields-"]'
  );
  if (!variantMetafieldsElement) return;

  const metafields = JSON.parse(variantMetafieldsElement.textContent);
  const sectionId = variantMetafieldsElement.id.replace(
    "VariantMetafields-",
    ""
  );

  function updateMetafields(variantId) {
    const data = metafields[variantId];
    if (!data) return;

    // Update description
    const descriptionEl = document.getElementById(
      `VariantDescriptionTag-${sectionId}`
    );
    if (descriptionEl) {
      descriptionEl.innerHTML = data.description_tag || "";
    }

    // Update bullets
    const bulletsEl = document.getElementById(
      `VariantFeaturesBullets-${sectionId}`
    );
    if (bulletsEl) {
      bulletsEl.innerHTML = "";
      for (let i = 1; i <= 5; i++) {
        const bullet = data[`bullet_${i}`];
        if (bullet) {
          const li = document.createElement("div");
          li.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/></svg>
            <span>${bullet}</span>
          `;
          bulletsEl.appendChild(li);
        }
      }
    }

    // Build specs object
        const specs = {
      // Prefer raw strings if present (e.g. "7.5 ft"), otherwise build from value + unit,
      // and if only value exists, still show it.
      Height: (function () {
        if (data.height_raw) return String(data.height_raw);
        if (data.height_value) {
          return data.height_unit
            ? `${data.height_value} ${data.height_unit}`
            : String(data.height_value);
        }
        return "";
      })(),

      Width: (function () {
        if (data.width_raw) return String(data.width_raw);
        if (data.width_value) {
          return data.width_unit
            ? `${data.width_value} ${data.width_unit}`
            : String(data.width_value);
        }
        return "";
      })(),

      Weight: (function () {
        if (data.weight_raw) return String(data.weight_raw);
        if (data.weight_value) {
          return data.weight_unit
            ? `${data.weight_value} ${data.weight_unit}`
            : String(data.weight_value);
        }
        return "";
      })(),

      Shape: data.shape,
      LightCount: data.light_count,
      BulbType: data.bulb_type,
      BulbColor: data.bulb_color,
      TipCount: data.tip_count,
      PreLit: data.prelit,
      Color: data.color,
      Materials: data.materials,
      DescriptionExtra: data.description_extra,
    };

    // Loop through each spec tile
    for (const key in specs) {
      let value = specs[key];

      // Special case: LightCount "0" or 0 => "Unlit"
      if (key === "LightCount" && (value === "0" || value === 0)) {
        value = "Unlit";
      }

      const wrapper = document.getElementById(`Variant${key}-${sectionId}`);
      const valueEl = wrapper?.querySelector(".spec-value");
      if (!wrapper || !valueEl) continue;

      // Robust "has value" check
      const hasValue =
        value !== null &&
        value !== undefined &&
        String(value).trim() !== "";

      if (!hasValue) {
        // truly no data for this spec on this variant
        valueEl.textContent = "";
        wrapper.style.display = "none";
        continue; // skip icon/description logic
      }

      const text = String(value).trim();
      valueEl.textContent = text;
      wrapper.style.display = ""; // show tile

      // Added additional styling and images for each section
      switch (key) {
        case "Shape": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-shape-icon]')) {
            const img = document.createElement("img");
            img.src = ""; // your Shape icon URL
            img.alt = "";
            img.setAttribute("data-shape-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-shape-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-shape-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "LightCount": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-light-count-icon]')) {
            const img = document.createElement("img");
            if (text === "Unlit" || text === "0") {
              img.src = ""; // unlit icon URL
            } else {
              img.src = ""; // lit icon URL
            }
            img.alt = "";
            img.setAttribute("data-light-count-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-light-count-desc]')) {
            if (text === "Unlit" || text === "0") {
              // no extra description for unlit
            } else {
              const p = document.createElement("p");
              p.textContent = "";
              p.setAttribute("data-light-count-desc", "true");
              p.classList.add("spec-inner-description");
              parent.appendChild(p);
            }
          }
          break;
        }

        case "BulbType": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-bulb-type-icon]')) {
            const img = document.createElement("img");
            if (text === "Incandescent") {
              img.src = ""; // incandescent icon URL
            } else {
              img.src = ""; // LED icon URL
            }
            img.alt = "";
            img.setAttribute("data-bulb-type-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-bulb-type-desc]')) {
            const p = document.createElement("p");
            if (text === "Incandescent") {
              p.textContent = "";
            } else {
              p.textContent = "";
            }
            p.setAttribute("data-bulb-type-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "BulbColor": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-bulb-color-icon]')) {
            const img = document.createElement("img");
            if (text === "Clear Incandescent" || text === "Warm White LED") {
              img.src = ""; // warm/clear icon URL
            } else if (
              text === "Clear/Multi Incandescent" ||
              text === "Dual Function Clear/Multi LED"
            ) {
              img.src = ""; // multi icon URL
            } else {
              img.src = ""; // unlit/other icon URL
            }
            img.alt = "";
            img.setAttribute("data-bulb-color-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-bulb-color-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-bulb-color-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "TipCount": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-tip-count-icon]')) {
            const img = document.createElement("img");
            img.src = ""; // tip count icon URL
            img.alt = "";
            img.setAttribute("data-tip-count-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-tip-count-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-tip-count-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "PreLit": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-prelit-icon]')) {
            const img = document.createElement("img");
            img.src = ""; // pre-lit icon URL
            img.alt = "";
            img.setAttribute("data-prelit-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-prelit-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-prelit-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "Color": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-color-icon]')) {
            const img = document.createElement("img");
            img.src = ""; // color icon URL
            img.alt = "";
            img.setAttribute("data-color-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-color-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-color-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        case "Materials": {
          const parent = valueEl.parentElement;
          if (parent && !parent.querySelector('img[data-materials-icon]')) {
            const img = document.createElement("img");
            img.src = ""; // materials icon URL
            img.alt = "";
            img.setAttribute("data-materials-icon", "true");
            parent.insertBefore(img, parent.firstChild);
          }
          if (parent && !parent.querySelector('p[data-materials-desc]')) {
            const p = document.createElement("p");
            p.textContent = "";
            p.setAttribute("data-materials-desc", "true");
            p.classList.add("spec-inner-description");
            parent.appendChild(p);
          }
          break;
        }

        // Add more cases if needed
      } // end switch
    } // end for specs
  } // end updateMetafields

  function getCurrentVariantId() {
    return (
      window.ShopifyAnalytics?.meta?.selectedVariantId?.toString() ||
      document.querySelector('form[action^="/cart"] input[name="id"]')?.value
    );
  }

  function onVariantChange(callback) {
    let lastVariant = getCurrentVariantId();
    const observer = new MutationObserver(() => {
      const currentVariant = getCurrentVariantId();
      if (currentVariant && currentVariant !== lastVariant) {
        lastVariant = currentVariant;
        callback(currentVariant);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initial load
  const initialVariantId = getCurrentVariantId();
  if (initialVariantId) updateMetafields(initialVariantId);

  // React to variant changes
  onVariantChange((newVariantId) => {
    updateMetafields(newVariantId);
  });
});
